
/**
 * Arreglo con los campos que manejan los registros dentro de las capas
 */
export const commonFieldsLayer = [
  {
    name: 'ObjectID',
    type: 'oid',
  },
  {
    name: 'nombre',
    type: 'string',
  },
  {
    name: 'categoria',
    type: 'string',
  },
  {
    name: 'telefono',
    type: 'string',
  },
  {
    name: 'direccion',
    type: 'string',
  },
  {
    name: 'nombre_busqueda',
    type: 'string',
  },
  {
    name: 'url',
    type: 'string',
  },
];

/**
 * Arreglo con los campos que manejan los registros dentro de las capas de tipo poligono
 */
export const commonFieldsPolygonLayer = [
  {
    name: 'ObjectID',
    type: 'oid',
  },
  {
    name: 'nombre',
    type: 'string',
  },
  {
    name: 'categoria',
    type: 'string',
  },
  {
    name: 'tipoInmueble',
    type: 'string',
  },
  {
    name: 'usoInmueble',
    type: 'string',
  },
  {
    name: 'sector',
    type: 'string',
  },
  {
    name: 'direccion',
    type: 'string',
  },
  {
    name: 'id',
    type: 'string',
  },
  {
    name: 'codCatastro',
    type: 'string',
  },
  {
    name: 'nroAnteriorCatastro',
    type: 'string',
  },
  {
    name: 'zonificacion',
    type: 'string',
  },
];

/**
 * Función encargada de crear un template para punto, recibiendo como parámtro el título
 */
export const createPopupTemplate = title => {
  return {
    title,
    content: [{
      type: 'fields',
      fieldInfos: [
        {
          fieldName: 'nombre',
          label: 'Nombre',
          visible: true,
        },
        {
          fieldName: 'categoria',
          label: 'Categoría',
          visible: false,
        },
        {
          fieldName: 'telefono',
          label: 'Teléfono',
          visible: true,
        },
        {
          fieldName: 'direccion',
          label: 'Dirección',
          visible: true,
        },
        {
          fieldName: 'nombre_busqueda',
          label: 'Nombre de búsqueda',
          visible: false,
        },
        {
          fieldName: 'url',
          label: 'Sitio web',
          visible: true,
        },
      ],
    }],
  };
};

/**
 * Función encargada de crear un template para poligono, recibiendo como parámetro el título
 */
export const createPolygonPopupTemplate = title => {
  return {
    title,
    content: [{
      type: 'fields',
      fieldInfos: [
        {
          fieldName: 'nombre',
          label: 'Nombre',
          visible: true,
        },
        {
          fieldName: 'categoria',
          label: 'Categoría',
          visible: false,
        },
        {
          fieldName: 'tipoInmueble',
          label: 'Tipo de inmueble',
          visible: true,
        },
        {
          fieldName: 'usoInmueble',
          label: 'Uso del inmueble',
          visible: true,
        },
        {
          fieldName: 'sector',
          label: 'Sector',
          visible: true,
        },
        {
          fieldName: 'direccion',
          label: 'Dirección',
          visible: true,
        },
        {
          fieldName: 'id',
          label: 'Cod. parcela',
          visible: true,
        },
        {
          fieldName: 'codCatastro',
          label: 'Cod. catastro',
          visible: true,
        },
        {
          fieldName: 'nroAnteriorCatastro',
          label: 'Nro. anterior',
          visible: true,
        },
        {
          fieldName: 'zonificacion',
          label: 'Zonificación',
          visible: true,
        },
      ],
    }],
  };
};
/**
 * Función encargada de crear un gráfico de punto en base a los parámetros recibidos
 */
export const createGraphic = (Graphic, d) => {
  return new Graphic({
    attributes: {
      OBJECTID: d.id,
      categoria: d.categoria,
      nombre: d.nombre,
      telefono: d.telefono,
      direccion: d.direccion,
      nombre_busqueda: d.nombre_busqueda,
      latitude: d.lat_y,
      longitude: d.lng_x,
      url: null,
    },
    geometry: {
      type: 'point',
      longitude: d.lng_x,
      latitude: d.lat_y,
    },
  });
};

/**
 * Función encargada de crear un grafico de poligono en base a los parámetros recibidos
 */
export const createPolygonGraphic = (Graphic, d) => {
  try {
    const coordinatesCleaned = d.COORDINATES.replaceAll('lng', '"lng"').replaceAll('lat', '"lat"');
    // .replaceAll(/\s/g, '')
    // .replaceAll(/(\{})\1+/g, '{')
    // .replaceAll(/(\})\1+/g, '}')
    // .replaceAll(/(\{"lng":)\1+/g, '{"lng":')
    // .replace(/,\s*$/, '');

    const coordinates = d.COORDINATES ? JSON.parse(`[${coordinatesCleaned}]`) : [];
    const paths = coordinates.map(c => ([c.lng, c.lat]));
    let direccion = d.NB_ACCESO_DIR;
    if (direccion) {
      if (d.NB_ACCESO_ENTRE && d.NB_ACCESO_Y) {
        direccion = `${d.NB_ACCESO_DIR} ENTRE ${d.NB_ACCESO_ENTRE} Y ${d.NB_ACCESO_Y}`;
      } else if (d.NB_ACCESO_ENTRE && !d.NB_ACCESO_Y) {
        direccion = `${d.NB_ACCESO_DIR} CON ${d.NB_ACCESO_ENTRE}`;
      }
    }

    return new Graphic({
      attributes: {
        OBJECTID: d.id,
        nombre: d.NB_INMUEBLE,
        categoria: d.categoria,
        tipoInmueble: d.DS_TIP_INMUEBLE,
        usoInmueble: d.DS_TIP_USO_INMUEBLE,
        sector: d.NO_SECTOR,
        direccion,
        id: d.id,
        codCatastro: d.ID_PARCELA,
        nroAnteriorCatastro: d.NU_CATASTRO_ANTERIOR,
        zonificacion: d.zonificacion,
      },
      geometry: {
        type: 'polyline',
        paths,
      },
    });
  } catch {
    return null;
  }
};

/**
 * Función encargada de crear una capa de puntos en base a los parámetros recibidos
 */
export const createLayer = ({ FeatureLayer, Graphic, data, title, popupTitle, icon, ...extraProps }) => {
  const graphics = data.map(d => createGraphic(Graphic, d));
  return new FeatureLayer({
    ...extraProps,
    visible: false,
    source: graphics,
    title,
    renderer: {
      type: 'simple',
      symbol: {
        type: 'picture-marker', // autocasts as new PictureMarkerSymbol()
        url: icon,
        width: '40px',
        height: '40px',
      },
    },
    geometryType: 'point',
    popupTemplate: createPopupTemplate(popupTitle),
    objectIdField: 'ObjectID',
    fields: commonFieldsLayer,
  });
};

/**
 * Función encargada de crear una capa de poligono en base a los parámetros recibidos
 */
export const createPolygonLayer = ({ FeatureLayer, Graphic, data, title, popupTitle, ...extraProps }) => {
  const graphics = data.map(d => createPolygonGraphic(Graphic, d)).filter(d => d !== null);
  return new FeatureLayer({
    ...extraProps,
    visible: false,
    source: graphics,
    title,
    renderer: {
      type: 'simple',
      symbol: {
        type: 'simple-fill',
        color: [241, 241, 241, 0.3],
        outline: {
          color: [128, 128, 128, 1],
          width: '0.5px',
        },
      },
    },
    geometryType: 'polyline',
    popupTemplate: createPolygonPopupTemplate(popupTitle),
    objectIdField: 'ObjectID',
    fields: commonFieldsPolygonLayer,
  });
};
